import homeWizardService from '../../../services/HomeWizardService';
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'PowerUsageMonthFetcher';

/**
 * Raw I/O for power usage per month — no cache, no state.
 */
class PowerUsageMonthFetcher extends CoreBase {
    _name = _name;

    /**
     * @param {number} start - epoch ms
     * @param {number} end - epoch ms, exclusive
     * @returns {Promise<object[]>}
     */
    fetch = async (start, end) => {
        try {
            const res = await homeWizardService.getMonthUsages(start, end);
            return res?.data?.items ?? [];
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };
}

const powerUsageMonthFetcher = new PowerUsageMonthFetcher();
export default powerUsageMonthFetcher;
